// @ts-nocheck
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '../../../../../components/Shared/Loader/Loading';
import useGetFormAme from '../../../../../hooks/Ame/useGetFormAme';
import Select from 'react-select';
import useLookupModule from '../../../../../hooks/Lookups/use-Lookup-Module';
import Pagination from '../../../../../components/Shared/Pagination/Pagination';
import AddRequests from './AddRequests';
import NoData from '../../../../../components/NoData/NoData';
import { Card } from '@components/card/card';

const AmeForm = () => {
  const { t, i18n } = useTranslation();
  const [selectedItem, setSelectedItem] = useState(null);
  const { OptionsModule } = useLookupModule();
  const { DynamicFormAme: FormList, loading } = useGetFormAme();
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(8);
  const [moduleId, setModuleId] = useState(null);
  const filteredSearch = FormList?.slice()?.filter(item => {
    const matchesSource = moduleId ? item.moduleId === moduleId : true;
    return matchesSource;
  });

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredSearch?.slice(indexOfFirstData, indexOfLastData);

  return (
    <>
      <Loading loading={loading}>
        {!selectedItem ? (
          <>
            <div className='row mb-4'>
              <div className='col-lg-6'>
                <div className='input-group flex-nowrap input-group-sm'>
                  <span className='input-group-text fw-bold'>{t('Search')}</span>
                  <div className='input-group'>
                    <div className='flex-fill position-relative'>
                      <div className='input-group border-0 '>
                        <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
                          <i className='fa fa-search opacity-5 text-theme'></i>
                        </div>
                        <input
                          type='text'
                          autoComplete='off'
                          className='form-control  ps-35px'
                          // value={search}
                          onChange={e => {
                            // setSearch(e.target.value);
                            setCurrentPage(1);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-lg-6'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>{t('Application')}</span>
                  <Select
                    classNamePrefix='react-select'
                    className='w-100'
                    isSearchable={true}
                    isClearable
                    options={OptionsModule?.filter(f => FormList?.some(item => item.moduleId === f.value))}
                    value={OptionsModule?.find(f => f.value === moduleId)}
                    onChange={option => {
                      setModuleId(option?.value);
                      setCurrentPage(1);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </div>
              </div>
            </div>

            <div className='row mb-4'>
              {FormList &&
                currentData?.map(item => (
                  <div className='col-xl-3 col-md-6 mb-3' key={item.id}>
                    <Card>
                      <div
                        className={`card h-100 shadow-sm border-hover ${
                          selectedItem?.id === item.id ? 'border-theme border-2' : ''
                        }`}
                        style={{ cursor: 'pointer', transition: 'all 0.2s ease-in-out' }}
                        onClick={() => setSelectedItem(item)}
                      >
                        <div className='card-body text-center'>
                          <div className='mb-3'>
                            <i
                              className={
                                item.icon
                                  ? item.icon.replace('fa-lg fa-fw me-2', '') + ' fs-1 text-theme'
                                  : 'bi bi-menu-up fs-1 text-theme'
                              }
                            ></i>
                          </div>
                          <h6 className='card-title fw-bold   mb-2'>
                            {i18n.language === 'ar' ? item.name2 : item.name}
                          </h6>
                          {item.description && (
                            <p className='card-text text-muted small mb-0'>
                              {i18n.language === 'ar' ? item.description2 : item.description}
                            </p>
                          )}
                        </div>
                        {selectedItem?.id === item.id && (
                          <div className='card-footer bg-theme bg-opacity-10 text-center py-2'>
                            <small className='text-theme fw-bold'>
                              <i className='fas fa-check-circle me-1'></i>
                              {t('Selected')}
                            </small>
                          </div>
                        )}
                      </div>
                    </Card>
                  </div>
                ))}

              {currentData?.length === 0 && (
                <div className='col-12'>
                  <NoData />
                </div>
              )}
            </div>
          </>
        ) : (
          <div>{selectedItem.id && <AddRequests FormId={selectedItem.id} onBack={() => setSelectedItem(null)} />}</div>
        )}

        {!selectedItem && (
          <Pagination
            filteredData={filteredSearch}
            dataPerPage={dataPerPage}
            handlePagination={pageNumber => setCurrentPage(pageNumber)}
            currentPage={currentPage}
          />
        )}
      </Loading>
    </>
  );
};

export default AmeForm;

// <div className='row mb-4'>
//           {FormList &&
//             currentData?.map(item => (
//               <div className='col-xl-3 col-md-6 ' key={item.id}>
//                 <div className='mailbox-detail-content'>
//                   <div className='mailbox-attachment1 w-100'>
//                     <Link
//                       onClick={() => setSelectedItem(item)} // عند النقر على عنصر يتم استبدال المحتوى بالمكون المختار
//                       to=''
//                       style={{ cursor: 'pointer' }}
//                     >
//                       <div className='document-file1 h-100px'>
//                         <i
//                           className={
//                             item.icon ? item.icon.replace('fa-lg fa-fw me-2', '') + ' pt-2 ' : 'bi bi-menu-up pt-2'
//                           }
//                         ></i>
//                       </div>
//                       <div className='document-name'>{i18n.language === 'ar' ? item.name2 : item.name}</div>
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             ))}

//           {currentData?.length === 0 && <NoData />}
//         </div>
